const players = Array.from(document.querySelectorAll('.js-player')).map(p => new Plyr(p));
//const players = Array.from(document.querySelectorAll(".js-player")).map((e=>new Plyr(e)))
